class Loading {
    constructor(timeout) {
        this.timeout = timeout
    }

    tryAgain() {
        if (this.onRetry) this.onRetry()
    }

    get active() {
        return this.loading || this.error
    }

    set active(_active) {
    }
}

angular.module('eficienciaFiscalModule')
    .component('loading', {
        controller: ["$timeout", Loading],
        bindings: {
            promise: '<',
            active: '=?',
            onRetry: '&?'
        },
        transclude: true,
        template: `
            <promise-tracker promise="$ctrl.promise" active="$ctrl.loading" error="$ctrl.error">
                <div class="clearfix" style="position: relative; min-height: {{ $ctrl.loading ? '146px' : 'auto' }}">
                    <div ng-if="$ctrl.loading" class="fade-animation overlay">
                        <highlighted>
                            <main>
                                <i class="fa fa-circle-o-notch fa-spin"></i>
                                Carregando...
                            </main>
                        </highlighted>
                    </div>
                    <div ng-if="!$ctrl.loading && $ctrl.error" class="fade-animation overlay">
                        <highlighted>
                            <main>
                                <i class="fa fa-exclamation-triangle"></i>
                                Ocorreu um erro ao carregar os dados.                                
                            </main>
                            <secondary ng-if="$ctrl.onRetry">
                                Deseja <a href="javascript:void(0)" ng-click="$ctrl.tryAgain()">tentar novamente? </a>
                            </secondary>
                        </highlighted>
                    </div>
                    <ng-transclude ng-class="{'loading-content': $ctrl.active}"></ng-transclude>
                <div>
            </promise-tracker>
        `
    })
